import { render, staticRenderFns } from "./CompatibilityList.vue?vue&type=template&id=78738a4e"
import script from "./CompatibilityList.vue?vue&type=script&lang=js"
export * from "./CompatibilityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LedSearchForm: require('/app/components/LedSearchForm.vue').default})
